import Link from 'next/link';
import React from 'react';
import { generatePath, RouteE } from 'src/constants/pages.constants';
import { useCardAssets } from 'src/features/common/collection/hooks/use-card-assets';
import { useDisplayName } from 'src/features/common/user/hooks/use-display-name.hooks';
import { useUserListEntities } from 'src/features/common/user/hooks/user-list.hooks';
import { Typography } from 'src/ui/common/atoms/typography';
import { LazyLoadMedia } from 'src/ui/common/organisms/lazy-load-media';
import { decodeHTMLEntities, wipeHtml } from 'src/utils/html.utils';
import {
    StyledCreatorName,
    StyledDescription,
    StyledImgPreviewWrapper,
    StyledImgWrapper,
    StyledInfo,
    StyledName,
    StyledWrapper,
} from './collection-card-big.styles';
import { IProps } from './collection-card-big.types';

export const CollectionCardBig: React.VFC<IProps> = ({ collection, testId }) => {
    const userListEntities = useUserListEntities();
    const assets = useCardAssets({ collection });

    const link = generatePath(RouteE.COLLECTION_VIEW, {
        id: collection.id,
    });

    const creator = userListEntities[collection.ownerId];

    const creatorName = useDisplayName(creator);

    const creatorLink = generatePath(RouteE.PROFILE, {
        login: creator?.login ?? '',
    });

    return (
        <Link href={link} prefetch={false}>
            <a rel="canonical">
                <StyledWrapper data-test-id={testId}>
                    <StyledImgWrapper>
                        <LazyLoadMedia ratio={65} src={assets.banner} retinaSrc={assets.bannerRetina} />
                    </StyledImgWrapper>
                    <StyledInfo>
                        <StyledImgPreviewWrapper>
                            <LazyLoadMedia width={76} height={76} src={assets.avatar} retinaSrc={assets.avatarRetina} />
                        </StyledImgPreviewWrapper>
                        {creatorName && (
                            <Link href={creatorLink} prefetch={false}>
                                <a rel="canonical">
                                    <StyledCreatorName tag="div" overflowLines={1} altTitle={creatorName} size="xs">
                                        {decodeHTMLEntities(creatorName)}
                                    </StyledCreatorName>
                                </a>
                            </Link>
                        )}
                        <StyledName justifyContent="center">
                            <Typography altTitle={collection.name} size="sm" variant="title" overflowLines={1} medium>
                                {decodeHTMLEntities(collection.name)}
                            </Typography>
                        </StyledName>
                        <StyledDescription size="sm" tag="div" overflowLines={2}>
                            {wipeHtml(collection.description)}
                        </StyledDescription>
                    </StyledInfo>
                </StyledWrapper>
            </a>
        </Link>
    );
};